// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'

import { Col, Row } from 'vant';

Vue.use(Col);
Vue.use(Row);

// import './assets/base.css'
import './assets/desktop.css'
import './assets/fonts/iconfont.css'
import './assets/newfonts/iconfont.css'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'vant/lib/index.css';
import { Lazyload } from 'mint-ui';
import { InfiniteScroll } from 'mint-ui';

Vue.use(InfiniteScroll);
Vue.use(Lazyload);
import DrawerLayout from 'vue-drawer-layout'
import {Button, Popover,RadioGroup, Radio,Icon,Tag,Divider,List,Cell,Tab, Tabs,Grid, GridItem,Picker,Field,Popup,Swipe,SwipeItem,CountDown,Uploader,Form,Notify  } from 'vant';
Vue.use(DrawerLayout);
Vue.use(Button);
Vue.use(Popover);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Icon);
Vue.use(CountDown);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(List);
Vue.use(Cell);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use( Swipe );
Vue.use( SwipeItem )
Vue.use(Picker);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Uploader);
Vue.use(Form);
Vue.use(Notify);
 
Vue.use(MintUI)
Vue.config.productionTip = false

// // 加载控制台wykwykwyk*************************
// export const loadScript = (url, callback) => {
//   const script = document.createElement('script')
//   script.onload = () => callback()
//   script.src = url
//   document.body.appendChild(script)
// }

// loadScript(
//   'https://res.wx.qq.com/mmbizwap/zh_CN/htmledition/js/vconsole/3.0.0/vconsole.min.js',
//   () => {
//     // eslint-disable-next-line
//     new VConsole()
//   })
//思维导图jsmind


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js